export default function setTitle({ props }) {
  const { client } = props
  window.document.title = client.name
}



// WEBPACK FOOTER //
// ./src/modules/App/actions/setTitle.js